import styled from 'styled-components';
import { UIElements } from '@ansvar-sakerhet/ui';

const ActionButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
`;

export const S = {
  ...UIElements,
  ActionButton,
};
